function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TOGGLED = "active";

var ToggleableComponent = /*#__PURE__*/function () {
  function ToggleableComponent() {
    var button = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, ToggleableComponent);

    this.button = button;
    this.component = component;

    this._setup();
  }

  _createClass(ToggleableComponent, [{
    key: "activate",
    value: function activate() {
      this.button.classList.add(TOGGLED);
      this.component.classList.add(TOGGLED);

      this._toggled(true);
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      this.button.classList.remove(TOGGLED);
      this.component.classList.remove(TOGGLED);

      this._toggled(false);
    }
  }, {
    key: "_toggled",
    value: function _toggled(toggled) {
      if (typeof this.toggleCallback !== "undefined") {
        this.toggleCallback(toggled);
      }
    }
  }, {
    key: "_setup",
    value: function _setup() {
      var _this = this;

      if (!this.button || !this.component) {
        console.warn("No button found.");
        return;
      } // Check if the component listener has already been attached.


      if (!this.button.classList.contains("attached")) {
        this.button.classList.add("attached");
        this.component.classList.add("attached");
        this.button.addEventListener("click", function () {
          if (!_this.button.classList.contains(TOGGLED)) {
            _this.activate();
          } else {
            _this.deactivate();
          }
        });
      }
    }
  }]);

  return ToggleableComponent;
}();

export { ToggleableComponent as default };